var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"a-loader"}},[(_vm.getLoaderState)?_c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader-logo"},[_vm._v("Loading...")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }